exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-sp-containers-QuizPage-___QuizPage__spinner___MIMTv {\n  width: 100vw;\n  height: 100vh;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n  .src-sp-containers-QuizPage-___QuizPage__spinner___MIMTv > svg {\n    width: 64px;\n    height: 64px;\n  }\n", ""]);

// exports
exports.locals = {
	"spinner": "src-sp-containers-QuizPage-___QuizPage__spinner___MIMTv"
};